import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoSpace]',
  standalone: true
})
export class NoSpaceDirective {

  // Evitar espacios al presionar la barra espaciadora
  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }

  // Evitar pegar contenido que incluya espacios
  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text') || '';

    if (pastedText.includes(' ')) {
      event.preventDefault();  // Evita que el contenido con espacios sea pegado
    }
  }
}

